export interface PricingContext {
  discountPercent: number;
  marginPercent: number;
}

export function calculatePrice(basePrice: number, ctx: PricingContext): number {
  const afterDiscount = basePrice * (1 - ctx.discountPercent / 100);
  const afterMargin = afterDiscount * (1 + ctx.marginPercent / 100);
  return Math.round(afterMargin * 100) / 100;
}

export const ZERO_PRICING: PricingContext = {
  discountPercent: 0,
  marginPercent: 0,
};
